module.exports = __webpack_public_path__ + "static/media/alguev2-min.0f288999.gif";